/* eslint-disable */
import { Button, message, Modal, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { RotateLeftOutlined, SnippetsOutlined } from "@ant-design/icons";
import "@/common.css";
import "./component/Details.css";
import api from "@/utils/api";
import http from "@/utils/http";
import commonFn from "@/utils/commonFn";
import DownloadMaintenancePhotosButton from "../DownloadMaintenancePhotosButton";
import JobSteps, { getMaintenanceId, isOk } from "./component/JobSteps";

export default function Details() {
  const location = useLocation();

  const [initLoading, setInitLoading] = useState(true);
  const [maintenanceId, setMaintenanceId] = useState("");
  const [processData, setProcessData] = useState(null);
  const [maintenance, setMaintenance] = useState(null);
  const [rollbackOpen, setRollbackOpen] = useState(false);
  const [rollbackLoading, setRollbackLoading] = useState(false);

  const fetchProcess = async (id) => {
    const res = await http.get(`${api.process}?id=${id}`);
    return res?.data || null;
  };

  const refreshProcess = async () => {
    try {
      setProcessData(await fetchProcess(maintenanceId));
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    let cancelled = false;
    const id = getMaintenanceId(location.search);

    const run = async () => {
      if (!id) {
        setInitLoading(false);
        return;
      }
      setInitLoading(true);
      try {
        const [proc, detail] = await Promise.all([
          fetchProcess(id),
          http.get(`${api.getShowDetailByMaintenanceId}?maintenanceId=${id}`),
        ]);
        if (cancelled) return;
        setMaintenanceId(id);
        setProcessData(proc);
        setMaintenance(detail?.data?.maintenanceInfo || null);
      } catch (e) {
        console.error(e);
      } finally {
        if (!cancelled) setInitLoading(false);
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [location.search, location.hash]);

  const handleRollback = async () => {
    setRollbackLoading(true);
    try {
      const res = await http.get(
        `${api.rollbackProcess}?maintenanceId=${maintenanceId}`,
      );
      if (isOk(res)) {
        message.success("Successfully!");
        setRollbackOpen(false);
        await refreshProcess();
      } else {
        commonFn.modalFailedFn(res);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setRollbackLoading(false);
    }
  };

  const hasData = !!processData?.one && !!maintenance?.id;

  return (
    <div className="orderMain">
      <div className="page_title">
        <span>
          <SnippetsOutlined style={{ marginRight: 8 }} />
          Viewing Job Progress
        </span>
        <div className="page_title_actions">
          <DownloadMaintenancePhotosButton
            maintenanceId={maintenance?.id}
            requestNo={processData?.one?.requestNo}
          />
          {processData?.rollbackButton === 1 && (
            <Button
              type="primary"
              icon={<RotateLeftOutlined />}
              onClick={() => setRollbackOpen(true)}
            >
              Step back
            </Button>
          )}
        </div>
      </div>

      <div className="stepMain">
        {initLoading ? (
          <div className="page_center">
            <Spin size="large" />
          </div>
        ) : !hasData ? (
          <div className="text_muted" style={{ padding: 20 }}>
            No data available
          </div>
        ) : (
          <JobSteps
            maintenanceId={maintenanceId}
            processData={processData}
            maintenance={maintenance}
            onRefresh={refreshProcess}
          />
        )}
      </div>

      <Modal
        title="Are you sure you want to step back?"
        open={rollbackOpen}
        onOk={handleRollback}
        onCancel={() => setRollbackOpen(false)}
        confirmLoading={rollbackLoading}
        centered
      />
    </div>
  );
}
